/* eslint-disable max-lines-per-function */
/* eslint-disable functional/prefer-readonly-type */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react'
import {
  Button,
  IconButton,
  Dialog,
  DialogContent,
  DialogActions,
  Grid,
  Typography,
  Tooltip,
} from '@mui/material'
import { EmergencyShare } from '@mui/icons-material'
import { useLang } from '../../../../hooks/useLang'
import useEntryState from '../../stores/EntryState'
import useEntryDispatchState from '../../stores/EntryDispatchState'
import { Downgraded, useHookstate, useState } from '@hookstate/core'
import useSystemState from '~/features/System/stores/SystemState'
import useOccurrenceState from '~/features/Occurrence/stores/OccurrenceState'
import useEntryCommentState, {
  CommentDataProps,
} from '../../stores/EntryCommentState'
import { LoadingButton } from '@mui/lab'
import DialogRedirect from './components/DialogRedirect'
import { authFetch } from '~/services/fetch'

interface DispatchButtonProps {
  readonly canDispatch?: boolean
  readonly dispatch?: () => Promise<void>
  readonly hasLatLng: boolean
  readonly disabled?: boolean
}

const defaultCommentsState: readonly CommentDataProps[] = []

export default function DispatchButton(props: DispatchButtonProps) {
  const { translate } = useLang()
  const open = useState(false)
  const openRedirectOccurrence = useState(false)
  const { entryDispatch } = useEntryDispatchState()
  const entryDispatchState = useState(entryDispatch())
  const { entry, validateActionsEntry, loadingsActionsDispatchEntry } =
    useEntryState()
  const { windowManager } = useSystemState()
  const { syncOccurrenceEditAttendent } = useOccurrenceState()
  const entryIdContinue = useHookstate<number | null>(0)
  const { allCurrentComments, sortComment } = useEntryCommentState()
  const allCommentsValue = allCurrentComments().attach(Downgraded).value
  const commentList = useState(defaultCommentsState)
  const dispatchesCodesGenerated = useHookstate<string[]>([])
  const [dispatchCheck, setDispatchCheck] = React.useState<{
    has_comment: boolean
    allow_dispatch: boolean
  } | null>(null)
  const [loadingCheck, setLoadingCheck] = React.useState(false)

  React.useEffect(() => {
    commentList.set(
      allCommentsValue
        ? allCommentsValue.map((element) => element).sort(sortComment)
        : []
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allCommentsValue])

  const handleClickOpen = async () => {
    if (!validateActionsEntry()) {
      console.error('validateActionsEntry retornou false')
      return
    }

    setLoadingCheck(true)
    setDispatchCheck(null)

    try {
      const response = await authFetch({
        url: `/entry/allow-dispatch-without-comment/${entry()?.id?.get()}`,
        method: 'GET',
      })
      setDispatchCheck(response.data)
    } catch (e) {
      console.error('Erro ao verificar permissão de despacho:', e)
      setDispatchCheck({
        has_comment: true,
        allow_dispatch: true,
      })
    } finally {
      setLoadingCheck(false)
      open.set(true)
    }
  }

  const handleClose = () => {
    open.set(false)
    setDispatchCheck(null)
  }

  const action = async () => {
    if (!props.dispatch) return

    await props
      .dispatch()
      .then((data) => {
        entryIdContinue.set(data['occurrence'])
        dispatchesCodesGenerated.set(
          data['dispatches'].map((dispatch) => dispatch['code'])
        )
      })
      .finally(() => loadingsActionsDispatchEntry.set(false))

    open.set(false)
    openRedirectOccurrence.set(true)
  }

  const continueOccurrence = () => {
    windowManager()['occurrenceList'].open.set(true)
    syncOccurrenceEditAttendent(entryIdContinue.get())
    windowManager()['occurrence'].open.set(true)
    openRedirectOccurrence.set(false)
  }

  const nextEntry = () => {
    windowManager()['occurrence'].open.set(false)
    openRedirectOccurrence.set(false)
  }

  const getDialogMessage = () => {
    if (!dispatchCheck) {
      return (
        <Typography sx={{ textAlign: 'center' }}>
          {translate('Carregando...')}
        </Typography>
      )
    }

    if (!dispatchCheck.allow_dispatch) {
      return (
        <Typography
          sx={{
            textAlign: 'center',
            color: 'error.main',
            fontWeight: 'bold',
          }}
        >
          {translate(
            'Não é possível enviar para os despachantes um atendimento sem comentários!'
          )}
        </Typography>
      )
    }

    if (dispatchCheck.has_comment) {
      return (
        <Typography sx={{ textAlign: 'center' }}>
          {translate(
            'Deseja enviar esse atendimento para tratamento por despachantes?'
          )}
        </Typography>
      )
    }

    return (
      <>
        <Typography
          sx={{
            textAlign: 'center',
            color: 'error.main',
            fontWeight: 'bold',
            mb: 1,
          }}
        >
          {translate('Você não adicionou comentário nesse atendimento!')}
        </Typography>
        <Typography
          sx={{
            textAlign: 'center',
          }}
        >
          {translate(
            'Deseja enviar esse atendimento para tratamento por despachantes?'
          )}
        </Typography>
      </>
    )
  }

  const isButtonDisabled = () => {
    return (
      !entryDispatchState.value.length ||
      (dispatchCheck !== null && !dispatchCheck.allow_dispatch)
    )
  }

  const iconDisabled = !props.canDispatch || loadingCheck

  return (
    <Grid item>
      <Tooltip
        title={translate('Send to dispatch')}
        componentsProps={{ tooltip: { sx: { fontSize: '14px', padding: '6px 10px' } } }}
      >
        <span style={{ display: 'inline-block' }}>
          <IconButton
            disabled={iconDisabled}
            onClick={handleClickOpen}
          >
            <EmergencyShare />
          </IconButton>
        </span>
      </Tooltip>
      <Dialog open={open.get()} onClose={handleClose}>
        <DialogContent>{getDialogMessage()}</DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined">
            {translate('Cancel')}
          </Button>
          <LoadingButton
            loading={loadingsActionsDispatchEntry.get()}
            variant="contained"
            disabled={isButtonDisabled()}
            onClick={action}
          >
            {`${translate('Send')}!`}
          </LoadingButton>
        </DialogActions>
      </Dialog>
      <DialogRedirect
        open={openRedirectOccurrence}
        codeOccurrence={`${entryIdContinue.get()}`}
        handleClose={nextEntry}
        handleAgree={continueOccurrence}
        closeLabel={'Next entry'}
        AgreeLabel={'Continue'}
        dispatchesCodesGenerated={dispatchesCodesGenerated}
      />
    </Grid>
  )
}
